<div [ngClass]="{
  'main-sidebar': true,
  'sidebar-petronas': !isCommercialization,
  'sidebar-comm': isCommercialization,
  'elevation-4': true
}">
  <div class="sidebar">
    <nav class="mt-2">
      <ul class="nav nav-pills nav-sidebar flex-column" id="menu">
        <li class="nav-item">
          <a *ngIf="showDashboard" [routerLink]="['/dashboard']" class="nav-link" [routerLinkActive]="['active']">
            <i class="nav-icon fa fa-dashboard"></i>
            <p>Dashboard </p>
          </a>
        </li>

        <li class="nav-item w-100" [routerLinkActive]="['menu-is-opening', 'menu-open', 'active']"
          style="cursor: pointer;">
          <a *ngIf="showAdministration" href="#submenu2" data-bs-toggle="collapse" class="nav-link"
            [class.active]="isActive('')">
            <i class="nav-icon fa fa-gears"></i>
            <p>Administration </p>
            <i class="right fa fa-angle-down"></i>
          </a>
          <ul class="collapse nav flex-column ms-1" id="submenu2" data-bs-parent="#menu">
            <li class="nav-item w-100" [routerLinkActive]="['active']">
              <a *ngIf="showUser" [routerLink]="['/users']" class="nav-link" [routerLinkActive]="['active']">
                <p>User Management</p>
              </a>
            </li>
            <li class="nav-item w-100" [routerLinkActive]="['active']">
              <a *ngIf="showRole" [routerLink]="['/roles']" class="nav-link" [routerLinkActive]="['active']">
                <p>Role Management</p>
              </a>
            </li>
            <!-- <li class="nav-item w-100" [routerLinkActive]="['active']">
              <a *ngIf="showInspectionDate" [routerLink]="['/inspectiondate']" class="nav-link" [routerLinkActive]="['active']">
                <p>Inspection Date</p>
              </a>
            </li> -->
            <li class="nav-item w-100" [routerLinkActive]="['active']">
              <a *ngIf="showPendingRequest" [routerLink]="['/pendingrequest']" class="nav-link" [routerLinkActive]="['active']">
                <p>Pending Request</p>
              </a>
            </li>
            <!-- <li class="nav-item w-100" [routerLinkActive]="['active']">
              <a *ngIf="showInspectionRequest" [routerLink]="['/inspectionrequest']" class="nav-link" [routerLinkActive]="['active']">
                <p>Inspection Data Request</p>
              </a>
            </li>
            <li class="nav-item w-100" [routerLinkActive]="['active']">
              <a *ngIf="showMetoceanPointsRequest" [routerLink]="['/metoceanpointsrequest']" class="nav-link" [routerLinkActive]="['active']">
                <p>Metocean Points Request</p>
              </a>
            </li>
            <li class="nav-item w-100" [routerLinkActive]="['active']">
              <a *ngIf="showVectorizedDataRequest" [routerLink]="['/vectorizeddatarequest']" class="nav-link" [routerLinkActive]="['active']">
                <p>Vectorized Data Request</p>
              </a>
            </li> -->
          </ul>
        </li>

        <li class="nav-item w-100" [routerLinkActive]="['menu-is-opening', 'menu-open', 'active']"
          style="cursor: pointer;">
          <a *ngIf="showPipelineManagement" href="#submenu4" data-bs-toggle="collapse" class="nav-link"
            [class.active]="isActive('')">
            <i class="nav-icon fa fa-bar-chart"></i>
            <p>Pipeline </p>
            <i class="right fa fa-angle-down"></i>
          </a>
          <ul class="collapse nav flex-column ms-1" id="submenu4" data-bs-parent="#menu">
            <li class="nav-item w-100" [routerLinkActive]="['active']">
              <a *ngIf="showPipelineManagement" [routerLink]="['/pipelinemanagement']" class="nav-link" [routerLinkActive]="['active']">
                <p>Pipeline Management</p>
              </a>
            </li>
            <li class="nav-item w-100" [routerLinkActive]="['active']">
              <a *ngIf="showUWI" [routerLink]="['/uwi']" class="nav-link" [routerLinkActive]="['active']">
                <p>UWI</p>
              </a>
            </li>
          </ul>
        </li>

        <li class="nav-item w-100" [routerLinkActive]="['menu-is-opening', 'menu-open', 'active']"
          style="cursor: pointer;">
          <a *ngIf="showMetocean" href="#submenu5" data-bs-toggle="collapse" class="nav-link"
            [class.active]="isActive('')">
            <i class="nav-icon fa fa-map-marker"></i>
            <p>Metocean </p>
            <i class="right fa fa-angle-down"></i>
          </a>
          <ul class="collapse nav flex-column ms-1" id="submenu5" data-bs-parent="#menu">
            <li class="nav-item w-100" [routerLinkActive]="['active']">
              <a *ngIf="showMetoceanPoints" [routerLink]="['/metoceanpoints']" class="nav-link" [routerLinkActive]="['active']">
                <p>Metocean Points</p>
              </a>
            </li>
            <li class="nav-item w-100" [routerLinkActive]="['active']">
              <a *ngIf="showVectorizedData" [routerLink]="['/vectorizeddata']" class="nav-link" [routerLinkActive]="['active']">
                <p>Vectorized Data</p>
              </a>
            </li>
            <li class="nav-item w-100" [routerLinkActive]="['active']">
              <a *ngIf="showGIS" [routerLink]="['/gis']" class="nav-link" [routerLinkActive]="['active']">
                <p>Pipeline Data Mapping</p>
              </a>
            </li>
          </ul>
        </li>

        <li class="nav-item w-100" [routerLinkActive]="['menu-is-opening', 'menu-open', 'active']"
          style="cursor: pointer;">
          <a *ngIf="showModel" href="#submenu6" data-bs-toggle="collapse" class="nav-link"
            [class.active]="isActive('')">
            <i class="nav-icon fa fa-line-chart"></i>
            <p>Model </p>
            <i class="right fa fa-angle-down"></i>
          </a>
          <ul class="collapse nav flex-column ms-1" id="submenu6" data-bs-parent="#menu">
            <li class="nav-item w-100" [routerLinkActive]="['active']">
              <a *ngIf="showSpan" [routerLink]="['/span']" class="nav-link" [routerLinkActive]="['active']">
                <p>Span</p>
              </a>
            </li>
            <li class="nav-item w-100" [routerLinkActive]="['active']">
              <a *ngIf="showPrediction" [routerLink]="['/prediction']" class="nav-link" [routerLinkActive]="['active']">
                <p>Prediction</p>
              </a>
            </li>
          </ul>
        </li>

        <li class="nav-item w-100" [routerLinkActive]="['menu-is-opening', 'menu-open', 'active']"
          style="cursor: pointer;">
          <a *ngIf="showSupport" href="#submenu7" data-bs-toggle="collapse" class="nav-link"
            [class.active]="isActive('')">
            <i class="nav-icon fa fa-question-circle"></i>
            <p>Support & Help </p>
            <i class="right fa fa-angle-down"></i>
          </a>
          <ul class="collapse nav flex-column ms-1" id="submenu7" data-bs-parent="#menu">
            <li class="nav-item w-100" [routerLinkActive]="['active']">
              <a *ngIf="showSpan" [routerLink]="['/userguide']" class="nav-link" [routerLinkActive]="['active']">
                <p>User Guide</p>
              </a>
            </li>
            <li class="nav-item w-100" [routerLinkActive]="['active']">
              <a *ngIf="showPrediction" [routerLink]="['/support']" class="nav-link" [routerLinkActive]="['active']">
                <p>Support</p>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  </div>
</div>